import CustomAutocomplete from '@UI/autocomplete/CustomAutocomplete';
import type { EditAsideSubjects } from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';

const AsideSubjects: React.FC<{
  config: EditAsideSubjects;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const editHref = useEditHref();
  const dispatch = useDispatch();
  const initialValue = useInitialValue(config.property);

  const onChange = (event, newValue) => {
    dispatch(patchNodeAction(getResourceKey(editHref), set({}, config.property, newValue)));
  };

  return (
    <>
      <label className="control-label">{config.label}</label>
      <div>
        <CustomAutocomplete
          multiple
          freeText
          defaultValue={initialValue}
          onChange={onChange}
          readOnly={readonly}
        />
      </div>
    </>
  );
};

AsideSubjects.displayName = 'AsideSubjects';

export default AsideSubjects;

AsideSubjects.propTypes = {
  config: any,
  readonly: any,
};
